<script setup lang="ts">
/***
 * template to show array of POS
 */
import { useI18n } from 'vue-i18n';

import type { PaginatedDataTableCellProps } from '@/components/paginated-datatable/templates/templateTypes';
import { ConnectedByV1Dto, type SimpleConnectV1Dto } from '@/openapi';
import { navigationItems } from '@/router/navigation';

const { t } = useI18n();
const posIcon = `${navigationItems?.find((a) => a.name === 'pointOfSales')?.icon ?? 'mdi mdi-point-of-sale'} sey-icon mr-1`;
const ticketIcon = `${navigationItems?.find((a) => a.name === 'tickets')?.icon ?? 'mdi mdi-tag-check-outline'} sey-icon mr-1`;
const connectionType = ConnectedByV1Dto['connectionType'];
const props = defineProps<PaginatedDataTableCellProps>();
</script>

<template>
  <div class="flex flex-col gap-2">
    <div v-for="arrayValue in props.cell as Array<SimpleConnectV1Dto>" :key="arrayValue.id">
      <div>
        <span :class="posIcon"> </span>
        <RouterLink class="a-inline" :to="`/pointofsales/${arrayValue.id}`">{{
          arrayValue.name
        }}</RouterLink>
      </div>
      <div v-for="connValue in arrayValue.connectedBy" :key="connValue.id">
        <div v-if="connValue.connectionType === connectionType['TICKET']">
          <span :class="ticketIcon"> </span>
          <RouterLink class="a-inline" :to="`/tickets/${connValue.id}`">{{
            t('labels.connectedBy', { source: t('labels.tickets') })
          }}</RouterLink>
        </div>
      </div>
    </div>
  </div>
</template>
